import React from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import classes from 'components/common/ErrorPages/ErrorPages.module.scss';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';

const InternalServer = () => {
    return (
        <div className={classes.message}>
            <div className={classes.description}>
                <h1>Oops!</h1>
                <h2>Backend Server Error</h2>
            </div>
            <div>
                <Link to={'/'}>Go to homepage</Link> or{' '}
                <Link to={AppRoutes.buildPath(AppRoutes.DASHBOARD_PLANNING_PATH, executionConfig.programLibrary.link)}>
                    Program Library
                </Link>
            </div>
        </div>
    );
};
export default InternalServer;
